import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c56a434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-autocomplete-text-input--before" }
const _hoisted_2 = ["disabled", "readonly"]
const _hoisted_3 = { class: "oxd-autocomplete-text-input--after" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes),
    style: _normalizeStyle(_ctx.style)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "beforeInput", {}, undefined, true)
    ]),
    _createElementVNode("input", _mergeProps({
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
    }, _ctx.$attrs, {
      disabled: _ctx.disabled,
      readonly: _ctx.readonly
    }), null, 16, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "afterInput", {}, undefined, true),
      (_ctx.clear)
        ? (_openBlock(), _createBlock(_component_oxd_icon, {
            key: 0,
            class: "oxd-autocomplete-text-input--clear",
            name: "x",
            onClick: _ctx.onClear
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 6))
}